import React, { ReactElement, useContext } from 'react'

import Fieldset from '../../Common/Components/Fieldset'
import Heading from '../../Common/Components/Heading'
import P from '../../Common/Components/P'
import FormRow from '../../Common/Components/FormRow'
import Checkbox from '../../Common/Components/Checkbox'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { UnreturnedCalls as UnreturnedCallsLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'

// CSS imports. Commented out because of current build process.
// import './unreturnedCalls.scss'

/**
 * Component properties type.
 */
type Props = {
    includeEndedOnHold: boolean
    setIncludeEndedOnHold: (checked: boolean) => void
    includeEscaped: boolean
    setIncludeEscaped: (checked: boolean) => void
}

/**
 * Unreturned calls section of SLA/KPI tab.
 *
 * @param includeEndedOnHold Report property.
 * @param setIncludeEndedOnHold Setter for corresponding report property.
 * @param includeEscaped Report property.
 * @param setIncludeEscaped Setter for corresponding report property.
 */
const UnreturnedCalls: React.FC<Props> = ({
    includeEndedOnHold,
    setIncludeEndedOnHold,
    includeEscaped,
    setIncludeEscaped
}: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('UnreturnedCalls')

    return (
        <Fieldset className={'unreturned-calls'}>
            <Heading level={HeadingLevel.ONE}>
                {language.get(UnreturnedCallsLanguage.UnreturnedCalls_SectionHeader)}
            </Heading>
            <P>{language.get(UnreturnedCallsLanguage.UnreturnedCalls_SectionPara)}</P>
            <FormRow isInline className={'include-ended-on-hold'}>
                <Checkbox
                    className='left-aligned-checkbox'
                    labelLeft={language.get(UnreturnedCallsLanguage.IncludeendedonholdLabel)}
                    onChange={setIncludeEndedOnHold}
                    isChecked={includeEndedOnHold}
                />
            </FormRow>
            <FormRow isInline className={'include-escaped'}>
                <Checkbox
                    className='left-aligned-checkbox'
                    labelLeft={language.get(UnreturnedCallsLanguage.IncludeescapedLabel)}
                    onChange={setIncludeEscaped}
                    isChecked={includeEscaped}
                />
            </FormRow>
        </Fieldset>
    )
}

export default React.memo(UnreturnedCalls)
